@if (currentProgramsList?.length) {
  <div class="textgreysmall p-t-xs p-l-md p-r-md text-align-left" >
    <p class="text-gray-light font-size-12">CURRENT PROGRAMS</p>
    @for (currentProgram of currentProgramsList; track currentProgram; let lastItem = $last; let i = $index) {
      <div>
        @if (currentProgram?.id !== programId) {
          <span>
            <p class="text-cyan-blue cursor-pointer" (click)="setSelectedProgram(currentProgram)">{{currentProgram?.name}} ({{ currentProgram?.dtStart }} - {{ currentProgram?.dtEnd }})</p>
            @if (!lastItem && currentProgramsList[currentProgramsList?.length - 1]?.id !== programId) {
              <hr class="horizontal-line">
            }
          </span>
        }
      </div>
    }
  </div>
}
@if (upcomingProgramsList?.length) {
  <hr class="horizontal-line">
}
@if (upcomingProgramsList?.length) {
  <div class="textgreysmall text-align-left p-t-xs p-l-md p-r-md" >
    <p class="text-gray-light font-size-12">UPCOMING PROGRAMS</p>
    @for (upcomingProgram of upcomingProgramsList; track upcomingProgram; let lastItem = $last; let i = $index) {
      <div >
        @if (upcomingProgram?.id !== programId) {
          <span>
            <p class="text-cyan-blue cursor-pointer" (click)="setSelectedProgram(upcomingProgram)">{{upcomingProgram?.name}} ({{ upcomingProgram?.dtStart }} - {{ upcomingProgram?.dtEnd }})</p>
            @if (!lastItem && upcomingProgramsList[upcomingProgramsList?.length - 1]?.id !== programId) {
              <hr class="horizontal-line"  >
            }
          </span>
        }
      </div>
    }
  </div>
}